import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/73f16761-2ebc-4835-8094-03c6108c4562";
export const REGISTER_URL = "https://a.ntrk2.com/fa40aff5-77e1-4b93-bf37-140412a34c67";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://yesbr.loadprkw2a.com/download?openExternalBrowser=1&id=yyxy3crsmve3uh5";

export * from "./codes";
export * from "./context";
